export const EMPTY_STATE_MESSAGES = {
  NO_THEME: "No theme found.",
  NO_RESULTS: "No results found.",
  NO_ORGANIZATION: "Tenant does not exist.",
};
